<template>
    <transition
            mode="out-in"
            name="confirmation-backdrop-animation">
        <div class="confirmation-backdrop" v-if="showBackdrop">
            <transition
                    mode="out-in"
                    name="confirmation-content-animation">
                <div class="container" v-if="showContent">
                    <div class="row">
                        <div :class="{'col-lg-6 offset-lg-3': size === 'small', 'col-lg-8 offset-lg-2': size === 'medium', 'col-12': size === 'large'}">
                            <div class="card confirmation shadow">
                                <div class="card-header text-center">
                                    <!--<h2 class="text-white m-0">توجه!</h2>-->
                                    <slot name="header">
                                        <h2 class="text-white m-0">
                                            <i class="fa fa-bell-o"></i>
                                        </h2>
                                    </slot>
                                </div>
                                <div class="card-body">
                                    <slot class="text-white"></slot>
                                </div>
                                <div class="card-footer" v-if="this.confirmationType === 'default'">
                                    <button class="btn btn-white btn-round secondary" @click="close">بستن</button>
                                    <button class="btn btn-white btn-round success" @click="confirm">تایید</button>
                                </div>
                                <div class="card-footer" v-if="this.confirmationType === 'yes-no'">
                                    <button class="btn btn-white btn-round danger" @click="close">خیر</button>
                                    <button class="btn btn-white btn-round success" @click="confirm">بلی</button>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </transition>
        </div>
    </transition>
</template>

<script>
    export default {
        name: 'confirmation',
        props: {
            size: String,
            type: String
        },
        data() {
            return {
                showContent: false,
                showBackdrop: false,
                confirmationType: "default"
            }
        },
        mounted() {
            if (this.isEmpty(this.type)) {
                this.confirmationType = "default";
            } else {
                this.confirmationType = this.type;
            }
        },
        methods: {
            show() {
                this.showBackdrop = true;
                setTimeout(() => {
                    this.showContent = true;
                }, 100);
            },
            close() {
                this.showContent = false;
                setTimeout(() => {
                    this.showBackdrop = false;
                }, 100)
            },
            confirm() {
                this.$emit("confirm", true);
            }
        }
    }
</script>

<style lang="scss" scoped>
    .confirmation-backdrop-animation-enter-active, .confirmation-backdrop-animation-leave-active {
        transition: all .3s cubic-bezier(.215,.61,.355,1);
    }

    .confirmation-backdrop-animation-enter, .confirmation-backdrop-animation-leave-to
    {
        opacity: 0;
    }
    .confirmation-content-animation-enter-active, .confirmation-content-animation-leave-active {
        transition: all .3s cubic-bezier(.215,.61,.355,1);
        /*transition-delay: .2625s;*/
    }

    .confirmation-content-animation-enter
    {
        opacity: 0;
        transform: scale(1.25);
    }

    .confirmation-content-animation-leave-to {
        opacity: 0;
        transform: scale(1.25);
    }
    .card.confirmation {
        background: linear-gradient(87deg, #f5365c 0,#f56036 100%) !important;
    }
    .card.confirmation .card-header {
        background: linear-gradient(87deg, #f5365c 0,#f56036 100%) !important;
        border-color: rgba(255,255,255,.075);
    }
    .card.confirmation .card-body {
        color: #ffffff;
    }
    .card.confirmation .card-footer {
        border-color: rgba(255,255,255,.075);
        display: flex;
        justify-content: space-between;
        align-items: center;
    }
    .card.confirmation .card-footer .btn-white {
        box-shadow: 0 7px 14px rgba(50,50,93,.1), 0 3px 6px rgba(0,0,0,.08);
        color: #212529;
        background-color: #ffffff;
        border-color: #ffffff;
        margin: 0 0.5rem;
        width: 50%;
        max-width: 225px;
    }
    .card.confirmation .card-footer .btn-white.success:hover {
        background-color: #00e676;
        border-color: #00e676;
        color: #ffffff;
    }
    .card.confirmation .card-footer .btn-white.secondary:hover {
        background-color: #607d8b;
        border-color: #607d8b;
        color: #ffffff;
    }
    .card.confirmation .card-footer .btn-white.danger:hover {
        background-color: #ff1744;
        border-color: #ff1744;
        color: #ffffff;
    }
    .card.confirmation .card-header i.fa {
        font-size: 3rem;
    }
    .card.confirmation .card-body {
        .input-group.round {
            .input-group-prepend {
                .input-group-text {
                    background-color: transparent !important;
                }
            }
            .form-control {
                background: transparent !important;
            }
        }
    }
</style>